var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.583,
    height: 15.761,
    viewBox: "0 0 21.583 15.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-youtube",
    "data-name": "Icon feather-youtube",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_114",
    "data-name": "Trac\\xE9 114",
    d: "M20.672,8.154a2.474,2.474,0,0,0-1.727-1.78A64.1,64.1,0,0,0,11.291,6s-6.124,0-7.655.409A2.474,2.474,0,0,0,1.909,8.19,25.813,25.813,0,0,0,1.5,12.9a25.813,25.813,0,0,0,.409,4.744,2.474,2.474,0,0,0,1.727,1.709c1.531.409,7.655.409,7.655.409s6.124,0,7.655-.409a2.474,2.474,0,0,0,1.727-1.78,25.812,25.812,0,0,0,.409-4.673,25.812,25.812,0,0,0-.409-4.744Z",
    transform: "translate(-1.499 -6)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_115",
    "data-name": "Trac\\xE9 115",
    d: "M14.625,18.541l5.118-2.911L14.625,12.72Z",
    transform: "translate(-6.836 -8.732)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.ab6e1fdd1479fd949b271f6d0c3a8284.svg";
export { ForwardRef as ReactComponent };